import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Login, { } from '../src/components/login';
import Builds from './components/builds';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import Appbar from './components/app-bar';

ReactDOM.render(
  <BrowserRouter>
  <Switch>
  {/* <Route path = "/harmony" render={(props) => (<TestComponent test="hello" {...props}/>)} /> */}
    <Route exact path = "/home" component = {Appbar}/>     
    <Route path = "/harmony" component={ (props) => (
      <Builds timestamp={new Date().toString()} {...props} />
    )}/>
     <Route path = "/brownie" component={ (props) => (
      <Builds timestamp={new Date().toString()} {...props} />
    )}/>
     <Route path = "/Pavarotti" component={ (props) => (
      <Builds timestamp={new Date().toString()} {...props} />
    )}/>
    <Route path = "/goldMW" component={ (props) => (
      <Builds timestamp={new Date().toString()} {...props} />
    )}/>
    <Route exact path = "/" component = {Login}/>
  </Switch>  
  </BrowserRouter>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js